import { Fold, Lens, Traversal } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as Optics from "@discovery/sonic-api-ng-optics";
import { _Link2RouteUrl } from "../hamburger/optics";
export const Premium = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((name, pageMetadataDescription, route, src, descM) => ({
    name,
    pageMetadataDescription,
    route,
    src,
    descM,
}), Fold.compose(Res._Response(), Lens.path("attributes", "title"), M._Just()), Fold.compose(Res._Response(), Lens.path("attributes", "pageMetadataDescription"), M._Just()), Fold.compose(Optics._Col2Items, Res._Rel("link"), _Link2RouteUrl), Fold.compose(Optics._Col2Items, Res._Rel("link"), Res._Rel("images"), Res._ForEach(), Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response(), Lens.prop("attributes")), Fold.pre(Fold.compose(Res._Response(), Lens.path("attributes", "description"), M._Just()))));

